//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {windVane} from '../../../utils/tmallGenius'

export default {
  data() {
    return {
      deviceName: "",
      tips: ""
    };
  },
  beforeRouteEnter(to, from, next) {
    windVane.setNavTitle("添加设备");
    next();
  },
  /*------------------------------------------- 开始运行 -------------------------------------------------------*/
  created() {
    this.deviceName = this.$route.query.name;
    this.tips = {
      zigbeeMini: '请将主机接通网络和电源',
      zigbeeCurtainMoto: '接通电源，连续按键四次，第五次长按直到指示灯快闪，然后再按一次按键，指示灯就会慢闪',
    }[this.deviceName];
  },
  methods:{
    /*------------------------------------------- 绑定函数 -------------------------------------------------------*/
    /*  下一步点击
    * */
    nextStepClick() {
      //是主机
      if ( this.$route.query.deviceGeneralType === 'controller_zigbee'){
        let isFoundHub = false;
        let path = isFoundHub ? '/connect/zigbee/hub_list' : '/connect/zigbee/hub_list_not_found';
        //跳转
        this.$router.replace({
          path: path,
          query:{
            name: this.$route.query.name,
          }
        });
      }
      //是设备
      else{
        let self = this;
        this.$vux.confirm.show({
          title: "无法添加设备",
          content: '你还没有添加主机，请先添加主机后再试',
          /*  确认点击
          * */
          onConfirm() {
            //跳转
            self.$router.replace({
              path: '/connect/zigbee/hub_list',
              query:{
                name: self.$route.query.name,
              }
            });
          }
        });
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/pages/connect/zigbee/TurnOn.vue